import CryptoJS from 'crypto-js';
import Vue from 'vue';
import VueRouter from 'vue-router';
// import userStore from '@/store/modules/user';

import HomeView from '../views/HomeView.vue';
import NoAccessView from '../views/NoAccessView.vue';
import NotFound from '../views/NotFoundView.vue';
import Login from '../views/LoginView.vue';
import Module from '../views/ChooseModule.vue';
//base Information
import UserProfile from '../views/ProfileView.vue';
import UserManagment from '../views/BaseInformation/User/UserManagmentView.vue';
import AddUser from '../views/BaseInformation/User/AddUser.vue';
import EditUser from '../views/BaseInformation/User/EditUser.vue';
import UserPersonalInformation from '../views/BaseInformation/User/UserPersonalInformation.vue';
import Detailuser from '../views/BaseInformation/User/UserMoreInformation';
import OrganizationRole from '../views/BaseInformation/OrganizationRole.vue';
import EducationDegree from '../views/BaseInformation/EducationDegree.vue';
import Province from '../views/BaseInformation/Province.vue';
import City from '../views/BaseInformation/City.vue';
import Hospital from '../views/BaseInformation/Hospital.vue';
import Zone from '../views/BaseInformation/Zone.vue';
import Station from '../views/BaseInformation/Station.vue';
import CancelReason from '../views/BaseInformation/CancelReason.vue';
import DispatchCode from '../views/BaseInformation/DispatchCode.vue';
import FlagData from '../views/BaseInformation/FlagData.vue';
import OtherOrganization from '../views/BaseInformation/OtherOrganization.vue';
import PreDefinedNote from '../views/BaseInformation/PreDefinedNote.vue';
import Extension from '../views/BaseInformation/Extension.vue';
// chief-complaint
import ChiefComplaint from '../views/BaseInformation/ChiefComplaint/index.vue';
import ChiefComplaintAnswer from '../views/BaseInformation/ChiefComplaint/AnswerPage.vue';
import ChiefComplaintQuestion from '../views/BaseInformation/ChiefComplaint/QuestionPage.vue';
import ChiefComplaintClinicalTriage from '../views/BaseInformation/ChiefComplaint/ClinicalTriage.vue';
import ChiefComplaintAdviceGuidance from '../views/BaseInformation/ChiefComplaint/ChiefComplaintAdviceGuidance.vue';
// app-information
import Unit from '../views/BaseInformation/Unit.vue';
import OrderType from '../views/BaseInformation/OrderType.vue';
import DrugGroup from '../views/BaseInformation/DrugGroup.vue';
import VehicleType from '../views/BaseInformation/VehicleType.vue';
import Drug from '../views/BaseInformation/Drug/Drug.vue';
import AddDrug from '../views/BaseInformation/Drug/AddDrug.vue';
import DrugMoreInformation from '../views/BaseInformation/Drug/DrogMoreInformation.vue';
import DisabledPeople from '../views/BaseInformation/DisabledPeople.vue';
import Vehicle from '../views/BaseInformation/Vehicle.vue';
import VehicleQRCode from '../views/BaseInformation/VehicleQRCode.vue';
import Phone from '../views/BaseInformation/Phone.vue';
import UserGroup from '../views/BaseInformation/UserGroup/UserGroup.vue';
import UserGroupUser from '../views/BaseInformation/UserGroup/UserGroupUsers.vue';
import MedicalItem from '../views/BaseInformation/MedicalItem.vue';
import Tag from '../views/BaseInformation/Tag.vue';
// import TypeOfUrgency from '@/views/AppInformation/TypeOfUrgency.vue';
import StationCoverageZone from '../views/BaseInformation/StationCoverageZone.vue';
import ClientComputer from '../views/BaseInformation/ClientComputer.vue';
//Triage
import GeneralTriageQuestion from '../views/Triage/GeneralTeriageQuestion.vue';
import TriageAnswer from '../views/Triage/TriageAnswer.vue';
import AddTriageAnswer from '../views/Triage/AddTriageAnswer.vue';
import TriageQuestion from '../views/Triage/TriageQuestion.vue';
//setting
import Theme from '../views/Setting/ThemeView.vue';
import Setting800 from '../views/800/Setting800.vue';
//115
import Dashboard115 from '../views/115/Dashboard115View.vue';
import Mission115 from '../views/115/115MissionView.vue';
import UserRecentCalls115 from '../views/115/UserRecentCall.vue';
//800
import Dashboard800 from '../views/800/Dashboard800View.vue';
import Mission800 from '../views/800/800MissionView.vue';
//Eoc
import EocCurrentMissionView from '../views/Eoc/EocCurrentMissionView.vue';
import EocMap from '../views/Eoc/EocMap.vue';
//Dashboards
import Dashboards_115 from '../views/Dashboards/115/Dashboards_115.vue';
import Dashboards_115_TimeStatus from '../views/Dashboards/Dashboards_115_TimeStatus.vue';
import Dashboards_800 from '../views/Dashboards/800/Dashboards_800.vue';
import Dashboards_admission from '../views/Dashboards/Dashboards_admission.vue';
//NEW 800
import NewMissionWithMap800 from '../views/800/800NewMissionWithMap.vue';
import CurrentMission800 from '../views/800/800CurrentMissionView.vue';
import Ambulance800List from '../views/800/Ambulance800List.vue';
import TerminehList from '../views/800/termineh.view.vue';
import Ambulance107s from '../views/800/Ambulance107s.vue';
import HospitalListFor800 from '../views/800/HospitalListFor800.vue';
import DispatchMap from '../views/800/DispatchMap.vue';
import RecentCall800 from '@/views/800/RecentCall.vue';
import NotificationFor800 from '@/views/800/notification/notification.view.vue';
import NotificationCU from '@/views/800/notification/notification.CU.vue';
//admission
import DashboardAdmission from '../views/Admission/DashboardAdmission.vue';
import AdmissionMissions from '../views/Admission/AdmissionMissions.vue';
import AdmissionMap from '../views/Admission/AdmissionMap.vue';
//followUp
import DashboardFollowUp from '../views/FollowUp/DashboardFollowUp.vue';
import FollowUpMissions from '../views/FollowUp/FollowUpMissions.vue';
import FollowUpMission from '../views/FollowUp/FollowUpMission.vue';
import FollowUpPatiant from '../views/FollowUp/FollowUpPatiant.vue';
import FollowUpMap from '../views/FollowUp/FollowUpMap.vue';
//Doctor
import DoctorDashboard from '../views/Doctor/DoctorDashboard.vue';
import DoctorMissions from '../views/Doctor/DoctorMissions.vue';
import DoctorRecentCall from '../views/Doctor/DoctorRecentCall.vue';
//report
import CallReport115 from '../views/Report/115/CallReport115.vue';
import MissionReportView from '../views/Report/Shared/MissionReportView.vue';
import MissionReportExport from '../views/Report/Shared/MissionReportExport.vue';
import MissionLimitReportExport from '../views/Report/Shared/MissionLimitReportExport.vue';
import QcSurveyReport from '../views/Report/QC/QcSurveyReport.vue';
import QcOnlineUsersReport from '../views/Report/QC/QcOnlineUsersReport.vue';
import QcUsersLoginLogoutReport from '../views/Report/QC/QcUsersLoginLogoutReport.vue';
import QcCallsReport from '../views/Report/QC/QcCallsReport.vue';
import QcMissionTimesReport from '../views/Report/QC/QcMissionTimesReport.vue';
import QcMissionFenceTimesReport from '../views/Report/QC/QcMissionFenceTimesReport.vue';
import QcTechnicianPerformanceReport from '../views/Report/QC/QcTechnicianPerformanceReport.vue';
import QcUsersForQCReport from '../views/Report/QC/QcUsersForQCReport.vue';
import QcDNDTimesReport from '../views/Report/QC/QcDNDTimesReport.vue';
import DailyReportAmar from '../views/Report/Amar/DailyReportAmar.vue';
import AverageTimeReport from '../views/Report/Shared/averageTimeReport.vue';
import DailyByZoneExport from '../views/Report/Amar/Export/DailyByZoneExport.vue';
import DailyByGeographicalTypeExport from '../views/Report/Amar/Export/DailyByGeographicalTypeExport.vue';
import DailyByCodeExport from '../views/Report/Amar/Export/DailyByCodeExport.vue';
import PhoneActivityReport from '../views/Report/Amar/CodeActivityReport/PhoneActivityReport.vue';
import PhoneActivityDetailReport from '../views/Report/Amar/CodeActivityReport/PhoneActivityDetailReport.vue';
import RefuelReportAmar from '../views/Report/Amar/RefuelReportAmar.vue';
import HeatMapReportAmar from '../views/Report/Amar/HeatMapReportAmar.vue';
import CustomReportAmar from '../views/Report/Amar/CustomReportAmar.vue';
import CustomReportAmarItems from '../views/Report/Amar/CustomReportAmarItems.vue';
import CustomReportQc from '../views/Report/QC/customReport/index.vue';
import CustomReportSlugQc from '../views/Report/QC/customReport/item.vue';
//hospital
import HospitalDashboard from '../views/Hospital/HospitalDashboard.vue';
import HospitalMissions from '../views/Hospital/HospitalMissions.vue';
import HospitalMissionReport from '../views/Hospital/HospitalMissionReport.vue';
import HospitalMissionReportExport from '../views/Hospital/HospitalMissionReportExport.vue';
//QC
import DashboardQC from '../views/QC/DashboardQCView.vue';
import QcCheckListReport from '../views/QC/checkList/index.vue';
import QCReportsView from '../views/QC/QCReportsView.vue';
import QcUser115Dashboard from '../views/QC/UsersDashboard/QcUser115Dashboard.vue';
import QcUser800Dashboard from '../views/QC/UsersDashboard/QcUser800Dashboard.vue';
import QcUserTechnicianDashboard from '../views/QC/UsersDashboard/QcUserTechnicianDashboard.vue';
import QcUserDoctorDashboard from '../views/QC/UsersDashboard/QcUserDoctorDashboard.vue';
import QcUserAdmissionDashboard from '../views/QC/UsersDashboard/QcUserAdmissionDashboard.vue';
import User115AllCalls from '../views/QC/UsersDashboard/User115AllCalls.vue';
import User115AllLoginLogout from '../views/QC/UsersDashboard/User115AllLoginLogout.vue';
import QcAllCheckLists from '../views/QC/checkList/all.vue';
import QcCheckListDetails from '../views/QC/checkList/[slug].vue';
//amar
import AmarDashboard from '../views/Amar/AmarDashboard.vue';
import AmarReports from '../views/Amar/AmarReports.vue';
import AirAmbulanceWorkStartList from '../views/Report/Amar/airAmbulance/workStart/list.vue';
import AirAmbulanceTakeoffAndLanding from '../views/Report/Amar/airAmbulance/takeoffAndLanding.vue';
import HelicopterGrounding from '../views/Report/Amar/airAmbulance/hellicopterGrounding.vue';
import HelicopterReplacement from '../views/Report/Amar/airAmbulance/helicopterReplacement.vue';
import AirAmbulanceRefuel from '../views/Report/Amar/airAmbulance/refuel.vue';

import AirAmbulanceWorkStartDetail from '../views/Report/Amar/airAmbulance/workStart/slug.vue';
//OtherOrganization
import OtherOrganizationMissions from '../views/OtherOraganization/OtherOrganizationMissions.vue';
Vue.use(VueRouter);
const routes = [
  {
    path: '',
    name: 'login',
    component: Login,
  },
  {
    path: '*',
    component: NotFound,
    name: 'notfound',
  },
  {
    path: '/unauth',
    component: NoAccessView,
    name: 'unauth',
  },
  {
    path: '/modules/:id',
    name: 'module',
    component: Module,
  },
  {
    path: '/vehicle/QRCode',
    name: 'vehicleQRCode',
    component: VehicleQRCode,
  },
  {
    path: '/eoc/map',
    name: 'eocMap',
    component: EocMap,
  },
  {
    path: '/800/map',
    name: 'dispatchMap',
    component: DispatchMap,
  },

  {
    path: '/800/newMissionWithMap800',
    name: 'newMissionWithMap800',
    component: NewMissionWithMap800,
    beforeEnter: (to, from, next) => {
      let mypermision = getUserPermision();
      if (mypermision == 2) {
        return next();
      } else {
        return next('/unauth');
      }
    },
  },
  {
    path: '/followUp/map',
    name: 'followUpMap',
    component: FollowUpMap,
    beforeEnter: (to, from, next) => {
      let mypermision = getUserPermision();
      if (mypermision == 7) {
        return next();
      } else {
        return next('/unauth');
      }
    },
  },
  {
    path: '/admission/map',
    name: 'admissionMap',
    component: AdmissionMap,
  },
  //exports
  {
    path: '/report/mission/export/:id',
    name: 'missionReportExport',
    component: MissionReportExport,
  },
  //limit report
  {
    path: '/reportLimit/mission/export/:id',
    name: 'missionLimitReportExport',
    component: MissionLimitReportExport,
  },
  {
    path: '/report/amar/dailyByZone/:id',
    name: 'dailyByZoneExport',
    component: DailyByZoneExport,
    beforeEnter: (to, from, next) => {
      let mypermision = getUserPermision();
      if (mypermision == 11) {
        return next();
      } else {
        return next('/unauth');
      }
    },
  },
  {
    path: '/report/amar/dailyByGeographicalType/:id',
    name: 'dailyByGeographicalTypeExport',
    component: DailyByGeographicalTypeExport,
    beforeEnter: (to, from, next) => {
      let mypermision = getUserPermision();
      if (mypermision == 11) {
        return next();
      } else {
        return next('/unauth');
      }
    },
  },
  {
    path: '/report/amar/dailyByCode/:id',
    name: 'dailyByCodeExport',
    component: DailyByCodeExport,
    beforeEnter: (to, from, next) => {
      let mypermision = getUserPermision();
      if (mypermision == 11) {
        return next();
      } else {
        return next('/unauth');
      }
    },
  },
  {
    path: '/home',
    name: 'home',
    component: HomeView,
    children: [

      //Dashboards
      {
        path: '/dashboards/115',
        name: 'dashboards_115',
        component: Dashboards_115,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 15) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/dashboards/115/time-status',
        name: 'dashboards_time_status_115',
        component: Dashboards_115_TimeStatus,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 15) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/dashboards/800',
        name: 'dashboards_800',
        component: Dashboards_800,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 15) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/dashboards/admission',
        name: 'dashboards_admission',
        component: Dashboards_admission,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 15) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },


      {
        path: '/profile',
        name: 'profile',
        component: UserProfile,
      },
      //base information
      {
        path: '/usermanagment',
        name: 'user',
        component: UserManagment,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 1) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/userGroup',
        name: 'userGroup',
        component: UserGroup,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 1) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/userGroup/users/:id',
        name: 'userGroupUsers',
        component: UserGroupUser,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 1) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/user/add',
        name: 'addUser',
        component: AddUser,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 1) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/user/detail/:id',
        name: 'detailUser',
        component: Detailuser,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 1) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/user/edit/:id',
        name: 'editUser',
        component: EditUser,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 1) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/user/personalInfo/:id',
        name: 'userPersonalInformation',
        component: UserPersonalInformation,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 1) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/organizationRole',
        name: 'organizationRole',
        component: OrganizationRole,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 1) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/educationDegree',
        name: 'educationDegree',
        component: EducationDegree,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 1) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/province',
        name: 'province',
        component: Province,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 1) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/city',
        name: 'city',
        component: City,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 1) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/hospital',
        name: 'hospital',
        component: Hospital,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 1) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/zone',
        name: 'zone',
        component: Zone,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 1) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/station',
        name: 'station',
        component: Station,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 1) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/cancelReason',
        name: 'cancelReason',
        component: CancelReason,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 1) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/dispatchCode',
        name: 'dispatchCode',
        component: DispatchCode,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 1) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/flagData',
        name: 'flagData',
        component: FlagData,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 1) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/otherOrganization',
        name: 'otherOrganization',
        component: OtherOrganization,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 1) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/preDefinedNote',
        name: 'preDefinedNote',
        component: PreDefinedNote,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 1) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/extension',
        name: 'extension',
        component: Extension,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 1) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      // chiefComplaint
      {
        path: '/chiefComplaint',
        name: 'chiefComplaint',
        component: ChiefComplaint,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 1) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/chiefComplaint/:id/answers',
        name: 'chiefComplaintAnswers',
        component: ChiefComplaintAnswer,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 1) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/chiefComplaint/:id/questions',
        name: 'chiefComplaintQuestions',
        component: ChiefComplaintQuestion,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 1) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/chiefComplaint/:id/clinical_triage',
        name: 'ChiefComplaintClinicalTriage',
        component: ChiefComplaintClinicalTriage,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 1) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/chiefComplaint/:id/advice_guidance',
        name: 'ChiefComplaintAdviceGuidance',
        component: ChiefComplaintAdviceGuidance,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 1) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/unit',
        name: 'unit',
        component: Unit,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 1) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/orderType',
        name: 'orderType',
        component: OrderType,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 1) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/drugGroup',
        name: 'drugGroup',
        component: DrugGroup,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 1) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/vehicleType',
        name: 'vehicleType',
        component: VehicleType,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 1) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/disabledPeople',
        name: 'disabledPeople',
        component: DisabledPeople,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 1) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/vehicle',
        name: 'vehicle',
        component: Vehicle,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 1) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/phone',
        name: 'phone',
        component: Phone,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 1) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/drug',
        name: 'drug',
        component: Drug,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 1) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/drug/add/:id?',
        name: 'addDrug',
        component: AddDrug,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 1) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/drug/detail/:id',
        name: 'drugMoreInformation',
        component: DrugMoreInformation,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 1) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/medicalItem',
        name: 'medicalItem',
        component: MedicalItem,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 1) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      // نوع ماموریت غیر فعال شد
      // {
      //   path: '/type_of_urgency',
      //   name: 'type_of_urgency',
      //   component: TypeOfUrgency,
      //   beforeEnter: (to, from, next) => {
      //     let mypermision = getUserPermision();
      //     if (mypermision == 1) {
      //       return next();
      //     } else {
      //       return next('/unauth');
      //     }
      //   },
      // },
      {
        path: '/tag',
        name: 'tag',
        component: Tag,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 1) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/stationCoverageZone/:id',
        name: 'stationCoverageZone',
        component: StationCoverageZone,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 1) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/clientComputer',
        name: 'clientComputer',
        component: ClientComputer,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 1) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      //end base information
      //Triage
      {
        path: '/triage/generalQuestion/:id?',
        name: 'generalTriageQuestion',
        component: GeneralTriageQuestion,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 1) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/triage/question/:id?',
        name: 'triageQuestion',
        component: TriageQuestion,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 1) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/triage/answer/:id',
        name: 'triageAnswer',
        component: TriageAnswer,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 1) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/triage/answer/add/:id',
        name: 'addTriageAnswer',
        component: AddTriageAnswer,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 1) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      //setting
      {
        path: '/setting/theme',
        name: 'theme',
        component: Theme,
      },
      //115
      {
        path: '/115/dashboard',
        name: 'dashboard115',
        component: Dashboard115,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 3) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/115/mission',
        name: 'mission115',
        component: Mission115,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 3) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/115/user_recent-calls',
        name: 'userRecentCall115',
        component: CallReport115,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 3) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      //800
      {
        path: '/800/dashboard',
        name: 'dashboard800',
        component: Dashboard800,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 2) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/800/mission',
        name: 'mission800',
        component: Mission800,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 2) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      //NEW 800
      // {
      //   path: '/800/newMissionWithMap800',
      //   name: 'newMissionWithMap800',
      //   component: NewMissionWithMap800,
      //   beforeEnter: (to, from, next) => {
      //     let mypermision = getUserPermision();
      //     if (mypermision == 2) {
      //       return next();
      //     } else {
      //       return next('/unauth');
      //     }
      //   },
      // },
      {
        path: '/800/currentMission800',
        name: 'currentMission800',
        component: CurrentMission800,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 2) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },

      ///New 800
      {
        path: '/800/codes',
        name: 'ambulance800List',
        component: Ambulance800List,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 2) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/800/termineh_list',
        name: 'terminehList',
        component: TerminehList,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 2) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/800/setting',
        name: 'setting800',
        component: Setting800,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 2) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/800/10-7',
        name: 'ambulance107s',
        component: Ambulance107s,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 2) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/800/hospitals',
        name: 'hospital800List',
        component: HospitalListFor800,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 2) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/800/hospitals',
        name: 'hospital800List',
        component: HospitalListFor800,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 2) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/800/recent_calls',
        name: 'recent_800_calls',
        component: RecentCall800,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 2) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/800/notification/view',
        name: 'notification_for_800',
        component: NotificationFor800,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 2) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/800/notification/cu',
        name: 'notification_cu_for_800',
        component: NotificationCU,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 2) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },

      //Eoc
      {
        path: '/eoc/currentMissionEoc',
        name: 'currentMissionEoc',
        component: EocCurrentMissionView,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 14) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      //admission
      {
        path: '/admission/dashboard',
        name: 'dashboardAdmission',
        component: DashboardAdmission,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 6) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/admission/mission',
        name: 'admissionMissions',
        component: AdmissionMissions,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 6) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      //followUp
      {
        path: '/followUp/dashboard',
        name: 'dashboardFollowUp',
        component: DashboardFollowUp,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 7) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/followUp/missions',
        name: 'followUpMissions',
        component: FollowUpMissions,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 7) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/followUp/mission/:id',
        name: 'followUpMission',
        component: FollowUpMission,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 7) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/followUp/patiant/:id',
        name: 'followUpPatiant',
        component: FollowUpPatiant,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 7) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      //Doctor
      {
        path: '/doctor/dashboard',
        name: 'doctorDashboard',
        component: DoctorDashboard,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 8) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/doctor/recent_calls',
        name: 'doctor_recent_calls',
        component: DoctorRecentCall,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 8) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/doctor/missions',
        name: 'doctorMissions',
        component: DoctorMissions,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 8) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      //report
      {
        path: '/report/115/call',
        name: 'callReport115',
        component: UserRecentCalls115,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 3) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/report/mission',
        name: 'missionReport',
        component: MissionReportView,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (
            mypermision == 2 ||
            mypermision == 3 ||
            mypermision == 6 ||
            mypermision == 7 ||
            mypermision == 8 ||
            mypermision == 9 ||
            mypermision == 10 ||
            mypermision == 11 ||
            mypermision == 14
          ) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/report/qc/Survey',
        name: 'qcSurveyReport',
        component: QcSurveyReport,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 10) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/qc/report/custom',
        name: 'QcCustomReport',
        component: CustomReportQc,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();

          if (mypermision == 10) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/qc/report/custom/:id',
        name: 'QcCustomReportItem',
        component: CustomReportSlugQc,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 10) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/report/qc/onlineUsers',
        name: 'qcOnlineUsersReport',
        component: QcOnlineUsersReport,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 10) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/report/qc/usersLoginLogout',
        name: 'qcUsersLoginLogoutReport',
        component: QcUsersLoginLogoutReport,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 10) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/report/qc/calls',
        name: 'qcCallsReport',
        component: QcCallsReport,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 10 || mypermision == 11) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/report/qc/missionTimes',
        name: 'qcMissionTimesReport',
        component: QcMissionTimesReport,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 10) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/report/qc/missionFenceTimes',
        name: 'qcMissionFenceTimesReport',
        component: QcMissionFenceTimesReport,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 10) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/report/qc/technicianPerformance',
        name: 'qcTechnicianPerformanceReport',
        component: QcTechnicianPerformanceReport,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 10) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/report/qc/usersPerformance',
        name: 'qcUsersForQCReport',
        component: QcUsersForQCReport,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 10) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/report/qc/dndTimes',
        name: 'qcDNDTimesReport',
        component: QcDNDTimesReport,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 10) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/report/amar/dailyReport',
        name: 'dailyReportAmar',
        component: DailyReportAmar,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 11) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/report/amar/average_times_report',
        name: 'average-times-report',
        component: AverageTimeReport,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision === 10 || mypermision === 11) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      //hospital
      {
        path: '/hospital/dashboard',
        name: 'hospitalDashboard',
        component: HospitalDashboard,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 9) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/hospital/missions',
        name: 'hospitalMissions',
        component: HospitalMissions,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 9) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/hospital/missions/report',
        name: 'hospitalMissionReport',
        component: HospitalMissionReport,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 9) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/hospital/missions/report/export',
        name: 'hospitalMissionReportExport',
        component: HospitalMissionReportExport,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 9) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      //QC
      {
        path: '/qc/dashboard',
        name: 'qcDashboard',
        component: DashboardQC,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 10) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/qc/report/checkList',
        name: 'qcCheckListReport',
        component: QcCheckListReport,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 10) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/qc/report/checkList/:id',
        name: 'qcCheckListReportDetails',
        component: QcCheckListDetails,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 10) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/qc/report/allCheckList/:id?',
        name: 'qcAllCheckLists',
        component: QcAllCheckLists,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 10) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/qc/reports',
        name: 'qcReports',
        component: QCReportsView,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 10) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/qc/userPerformance/115/:id',
        name: 'qcUser115Dashboard',
        component: QcUser115Dashboard,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 10) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/qc/userPerformance/800/:id',
        name: 'qcUser800Dashboard',
        component: QcUser800Dashboard,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 10) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/qc/userPerformance/technician/:id',
        name: 'qcUserTechnicianDashboard',
        component: QcUserTechnicianDashboard,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 10) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/qc/userPerformance/doctor/:id',
        name: 'qcUserDoctorDashboard',
        component: QcUserDoctorDashboard,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 10) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/qc/userPerformance/admission/:id',
        name: 'qcUserAdmissionDashboard',
        component: QcUserAdmissionDashboard,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 10) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/qc/userPerformance/115/calls/:id',
        name: 'user115AllCalls',
        component: User115AllCalls,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 10) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/qc/user/all/loginlogouts/:id',
        name: 'user115AllLoginLogout',
        component: User115AllLoginLogout,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 10) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      //amar
      {
        path: '/amar/dashboard',
        name: 'amarDashboard',
        component: AmarDashboard,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 11) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/amar/reports',
        name: 'amarReports',
        component: AmarReports,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 11) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/amar/report/phoneActivity',
        name: 'phoneActivityReport',
        component: PhoneActivityReport,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 11) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/amar/report/phoneActivity/detail/:id',
        name: 'phoneActivityDetailReport',
        component: PhoneActivityDetailReport,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 11) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/amar/report/refuel',
        name: 'refuelReportAmar',
        component: RefuelReportAmar,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 11) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/amar/report/heatmap',
        name: 'heatMapReportAmar',
        component: HeatMapReportAmar,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 11) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/amar/report/custom',
        name: 'customReportAmar',
        component: CustomReportAmar,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 11) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/amar/report/air_ambulance/work_start',
        name: 'workStartList',
        component: AirAmbulanceWorkStartList,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 11) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/amar/report/air_ambulance/takeoff_and_landing',
        name: 'takeoffAndLanding',
        component: AirAmbulanceTakeoffAndLanding,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 11) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/amar/report/air_ambulance/helicopter_grounding',
        name: 'helicopterGrounding',
        component: HelicopterGrounding,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 11) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/amar/report/air_ambulance/helicopter_replacement',
        name: 'helicopterReplacement',
        component: HelicopterReplacement,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 11) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/amar/report/air_ambulance/refuel',
        name: 'airAmbulanceRefuel',
        component: AirAmbulanceRefuel,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 11) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/amar/report/air_ambulance/work_start/:slug',
        name: 'workStartDetail',
        component: AirAmbulanceWorkStartDetail,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 11) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
      {
        path: '/amar/report/custom/:id',
        name: 'customReportAmarItems',
        component: CustomReportAmarItems,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 11) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },

      //other organ
      {
        path: '/otherOrganization/missions',
        name: 'otherOrganizationMissions',
        component: OtherOrganizationMissions,
        beforeEnter: (to, from, next) => {
          let mypermision = getUserPermision();
          if (mypermision == 12) {
            return next();
          } else {
            return next('/unauth');
          }
        },
      },
    ],
  },
];
function getUserPermision() {
  // let user = userStore.state.user;

  if (localStorage.getItem('dash')) {
    let bytes = CryptoJS.AES.decrypt(localStorage.getItem('dash'), 'f9rr8Y2D96Klh87N');
    let moduleId = '';
    if (bytes.sigBytes != 0) {
      moduleId = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    } else {
      moduleId = '';
    }
    return moduleId;
  } else {
    this.$router.push({ name: 'login' });
  }
}
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
